/** User-visible names for readiness badge levels. Code values (professional, master) stay unchanged. */
export const BADGE_LEVEL_DISPLAY_LABELS = Object.freeze({
  novice: "Novice",
  apprentice: "Apprentice",
  professional: "Proficient",
  proficient: "Proficient",
  coach: "Coach",
  master: "Architect",
  architect: "Architect",
});

const LEVEL_BY_INDEX = ["novice", "apprentice", "professional", "coach", "master"];

/** Display label for a level code, any case, or its 0..4 index; unknown strings are returned capitalised. */
export function getBadgeLevelLabel(level) {
  if (typeof level === "number") {
    return BADGE_LEVEL_DISPLAY_LABELS[LEVEL_BY_INDEX[level]] || "";
  }
  if (typeof level !== "string" || level.trim() === "") return "";
  const trimmed = level.trim();
  return (
    BADGE_LEVEL_DISPLAY_LABELS[trimmed.toLowerCase()] ||
    trimmed.charAt(0).toUpperCase() + trimmed.slice(1)
  );
}

const CODE_BY_LEVEL_NAME = Object.freeze({
  novice: "novice",
  apprentice: "apprentice",
  professional: "professional",
  proficient: "professional",
  coach: "coach",
  master: "master",
  architect: "master",
});

/** Code value (apprentice, professional, coach, master, novice) for a code, UI name or 0..4 index; null if unknown. */
export function getBadgeLevelCode(level) {
  if (typeof level === "number") return LEVEL_BY_INDEX[level] || null;
  if (typeof level !== "string") return null;
  return CODE_BY_LEVEL_NAME[level.trim().toLowerCase()] || null;
}
